import '../../main.css';
import '../../icons.css';

import './index.css';

import '../../common';
import '../../okta-auth';

// Navbar
import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

$(window).on("load", function() {
    //The alert for access being denied after the user is relocated must be located on the index page
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has("AdminPageAccessDenied")){
        alert("You do not have the necessary permissions to access the Admin page.");
    }

    // Load in the navbar dynamically (this is 
    // how we reuse components in ancient times)
    $("#fwv-navbar-id").load("navbar.html", function() {
        attachDropdownListeners();
    });
})